var controllers = {
    chapterController: 'chapterController',
    searchController: 'searchController',
    homeController: 'homeController',
    manageFavoritesController: 'ManageFavoritesController',
    confirmController: 'ConfirmController',
    printingController: 'printingController',
    feedbackController: 'feedbackController',
    advanceSearchController: 'advanceSearchController',
    myReadingReceiptsController: 'MyReadingReceiptsController',
    personChapterConfirmsSumsListController: 'PersonChapterConfirmsSumsListController',
    metadataController: 'metadataController'
};

var modules = {
    chapterModule: 'chapterModule',
    homeModule: 'homeModule',
    printingModule: 'printingModule'
};

var commonGridColumns = {
    name: 'name',
    id: 'id',
    readingList: 'readingList',
    isConfirmed: 'isConfirmed',
    location: 'location',
    version: 'version',
    folderName: 'folderName',
    approvedDate: 'approvedDate',
    approvedBy: 'approvedBy',
    attachment: 'attachment',
    template: 'template',
    responsible: 'responsible',
    documentId: 'documentId',
    rowInfo: 'rowInfo',
    internet: 'internet',
    readingReceipt: 'readingReceipt',
    readingReceiptDtmConfirmed: 'readingReceiptDtmConfirmed'
};

var broadcastType = {
    favoriteTarget: 'favoriteTarget',
    documentOpenedTarget: 'documentOpenedTarget',
    gridSettingTarget: 'gridSetting',
    scrollTarget: 'scrolling',
    toggleSidebar: 'toggleSidebar',
    collapseExpandSidebar: 'collapseExpandSidebar',
    onTreeNavigation: 'onTreeNavigation',
    resetQuickSearchKeyword: 'resetQuickSearchKeyword',
    onOpeningSidebarMenu: 'onOpeningSidebarMenu',
    printItemTarget: 'printItemTarget',
    toggleFavoriteTarget: 'toggleFavoriteTarget',
    toggleEmailSubscriptionTarget: 'toggleEmailSubscriptionTarget',
    toggleOnlyFolderEmailSubscriptionTarget: 'toggleOnlyFolderEmailSubscriptionTarget',
    toggleGridSettingTarget: 'toggleGridSettingTarget',
    toggleReadingReceiptTarget: 'toggleReadingReceiptTarget',
    toggleDocumentFeedbackTarget: 'toggleDocumentFeedbackTarget',
    linkToDocumentManagement: 'linkToDocumentManagement',
    gridDataChanges: 'gridDataChanges',
	loadContentFieldDone: 'loadContentFieldDone',
    favoriteUpdate: 'favoriteUpdate',
    processAreaRouteChanged: 'processAreaRouteChanged',
    updateFavoritesProcesses: 'updateFavoritesProcesses',
    hideSidebarInMobileWhenOpenDocument: 'hideSidebarInMobileWhenOpenDocument'
};

var requestType = {
    addRequest: 'add',
    deleteRequest: 'delete',
    removeRequest: 'remove'
};

var tabStateType = {
    documentTabState: 'DocumentTabState',
    chapterTabState: 'ChapterTabState',
    homeTabState: 'HomeTabState',
    searchTabState: 'SearchTabState'
};

var documentTab = {
    readingReceipt: 'document-reading',
};

var prefix = {
    contentAnchorPrefix: '#p',
    groupDocumentAnchorPrefix: '#groupDocumentHeader-',
    hashbangPrefix: '#',
    baseUrlPrefix: '#!'
};

var specialCharacter = {
    comma: ',',
    space: ' ',
    openParenthesis: '(',
    closeParenthesis: ')',
    colon: ':',
    questionMark: '?'
};

var cssClass = {
    active: 'active',
    buttonFavorite: 'button-favorite',
    buttonFavoriteMobile: 'button-favorite-mobile',
    buttonFavorited: 'button-favorited',
    buttonFavoritedMobile: 'button-favorited-mobile',
    disabled: 'disabled',
    selected: 'selected',
    currentDrag: 'current-drag',
    dragEnter: 'drag-enter'
};

var documentTabs = {
    about: 'document-about',
    content: 'document-content',
    readingReceipt: 'document-reading',
    feedback: 'document-feedback',
    search: 'document-searchincontent',
    hearing: 'document-hearing'
};

var folderTabs = {
    about: 'chapter-about',
    content: 'chapter-content'
};

var manageFavoriteTabs = {
    folder: 'folder',
    document: 'document',
    emailSubscribed: 'emailSubscribed',
    processArea: 'processArea',
    process: 'process'
};

var tabContents = {
    about: 'about-tab',
    content: 'content-tab',
    readingReceipt: 'reading-receipt-tab',
    feedback: 'feedback-tab',
    search: 'search-in-content-tab',
    hearing: 'hearing-tab'
};

var documentContent = {
    topMenu: 'document-top-menu-identifier',
    content: 'document-content-identifier'
};

var homeContent = {
    whatNew: 'whatNewContainer',
    updatedFavorite: 'updatedFavoriteContainer',
    startPage: 'start-page',
    updatedFavoritePage: 'updatedFavoriteContainerPage',
    whatNewPage: 'whatNewContainerPage',
    readingListTab1: 'reading-list-tab1',
    readingListTab2: 'reading-list-tab2',
    readingListTab3: 'reading-list-tab3'
};

var homeTabs = {
    whatNew: 'what-new-tab',
    updatedFavorite: 'favorite-tab',
    startPage: 'master-tab',
    readingListTab: 'reading-list-tab',
    hearingTab: 'hearings-tab'
};

var folderContent = {
    content: 'folder-content-identifier',
    gridDocuments: 'gridController',
    showAllDocuments: 'showAllDocuments',
    topMenuLeft: 'topmenuleftid',
    topMenuRight : 'topmenurightid',
    gridDocumentClass: 'table.gridStyle.margin-bottom-0',
    scrollableTable: 'scrollableTable',
    gridDocumentsBody: '#gridController > tbody',
    groupMetatagView: 'group-metatag-view',
    groupMetatagList: 'group-meta-tag-list'
};

var collapseExpandClass = {
    collapse: 'expandcollapse-heading-collapsed',
    expand: 'expandcollapse-heading-expanded'
};

var collapseExpandEvent = {
    shown: 'shown.bs.collapse',
    hidden: 'hidden.bs.collapse'
};

var elementClass = {
    currentDrag: '.current-drag',
    tabTable: '.tabbable',
    frontPageCustomArea: '.frontpage-customer-area'
};

var elementId = {
    sidebarWrapper: '#sidebar-wrapper',
    reSizeBar: '#resizeBar'
};

var avoidCustomPageClass = 'avoid-custom-page';
var showAllDocumentsAdjustmentClass = 'show-all-documents-adjustment';

var constantValues = {
    topMenuHeight: 128,
    folderTabContentMinTop: 75,
    documentTabContentMinTop: 65
};

var mobileConstantValues = {
    topMenuHeight: 74,
    folderTabContentMinTop: 60,
    documentTabContentMinTop: 50
};

var folderInformationKeyStorage = 'FolderInformation';
var searchContainerId = 'searchContainer';
var localStorageKeys = {
    sidebarNavigateKey: 'SidebarNavigation',
    readDocuments: 'ReadDocuments',
    stateOfSticky: 'StateOfSticky'
};

var treeNodeTypes = {
    folder: 0,
    document: 1
};

var urlOpenHearingFeedback = '/document/{0}/hearing';
var urlOpenProcessHearing = 'process-fe/process-detail/viewsendtohearing/{0}/{1}'
var hasShownPublicAlertKeyStorage = 'HasShownPublicAlert';

var ELEMENT_SELECTORS = {
    FolderSelectionContainerSelector: '#folderSelection',
    FolderSelectionInputSelector: '#folderSelectionInput',
    FolderSelectionClearSelector: '#folderSelectionClear',
    FolderContainerClassSelector: 'folderSelection',
    DepartmentSelectionContainerSelector: '#departmentSelection',
    DepartmentSelectionInputSelector: '#departmentSelectionInput',
    DepartmentSelectionClearSelector: '#departmentSelectionClear',
    DepartmentContainerClassSelector: 'departmentSelection',
    RoleMemberSelectionContainerSelector: '#roleMemberSelection',
    RoleMemberSelectionInputSelector: '#roleMemberSelectionInput',
    RoleMemberSelectionClearSelector: '#roleMemberSelectionClear',
    RoleMemberContainerClassSelector: 'roleMemberSelection',
    NewsCategorySelectionContainerSelector: '#newsCategorySelection',
    NewsCategorySelectionInputSelector: '#newsCategorySelectionInput',
    NewsCategorySelectionClearSelector: '#newsCategorySelectionClear',
    NewsCategoryContainerClassSelector: 'newsCategorySelection',
    CountrySelectionContainerSelector: '#countrySelection',
    CountrySelectionInputSelector: '#countrySelectionInput',
    CountrySelectionClearSelector: '#countrySelectionClear',
    CountryContainerClassSelector: 'countrySelection',
    PositionSelectionContainerSelector: '#positionSelection',
    PositionSelectionInputSelector: '#positionSelectionInput',
    PositionSelectionClearSelector: '#positionSelectionClear',
    PositionContainerClassSelector: 'positionSelection',
    RoleSelectionContainerSelector: '#roleSelection',
    RoleSelectionInputSelector: '#roleSelectionInput',
    RoleSelectionClearSelector: '#roleSelectionClear',
    RoleContainerClassSelector: 'roleSelection',
    SearchRelatedDocumentContainerSelector: '#searchRelatedDocument',
    SearchRelatedDocumentInputSelector: '#searchRelatedDocumentInput',
    SearchRelatedDocumentClearSelector: '#searchRelatedDocumentClear',
    SearchRelatedDocumentContainerClassSelector: 'searchRelatedDocument'
};

var KEY_CODES = {
    ENTER: 13,
    ESCAPE: 27,
    UP_ARROW: 38,
    DOWN_ARROW: 40
};

/**
 * The definition of data type of columns in grid.
 */
var COLUMN_DATA_TYPES = {
    STRING_TEXT: 1,
    NUMBER: 2,
    STRING_DATE: 3,
    STRING_DATE_TIME: 4,
    BOOLEAN: 5
};

var SEARCH_LOG_LEVEL = {
    LOG_DOCUMENT_SELECTED: 0,
    LOG_DOCUMENT_SELECTED_AND_0_HIT: 1,
    LOG_DOCUMENT_SELECTED_AND_0_HIT_AND_NO_SELECTION: 2
}

var DOCUMENT_EXTENDABLE_TYPES = {
    NONE: 0,
    PARENT: 1,
    CHILD: 2
};

var searchFilterTypes = {
	handbookBackendSearch: 1,
	handbookReports: 2,
	deviationBackendSearch: 3,
	deviationReports: 4,
	riskBackendSearch: 5,
	riskReports: 6,
	hearingMembers: 7,
	anuualCycleReaders: 8,
	readingList: 9,
	riskDynamicSearch: 10
};

var DEVIATION_REPORTS_TYPES = {
    CATEGORY_NUMBER: 1,
    CATEGORY_NUMBER_PER_HANDLING_UNIT: 2,
    CATEGORY_YEAR_AND_MONTH_NUMBER: 3,
    CATEGORY_SEVERITY_NUMBER: 4,
    CATEGORY_KPI: 5,
    ACTIONS_NUMBER_AND_TYPE: 6,
    ACTIONS_NUMBER_PER_MONTH_PER_YEAR: 7,
    CATEGORY_NUMBER_PER_MONTH_PER_YEAR: 8,
    STATISTICS: 10,
    CATEGORY_COST_PER_YEAR: 11,
    CATEGORY_COST_PER_MONTH_PER_YEAR: 12,
    CATEGORY_NUMBER_PER_METATAG: 13,
    CATEGORY_NUMBER_PER_SUB_CATEGORY: 14,
    CATEGORY_CUSTOM_FIELD: 15,
    CATEGORY_EQUIPMENT: 16
};

var GROUP_TO_OPEN_AS_DEFAULTS = {
    NONE: 0,
    DOCUMENT: 1,
    PROCESS: 2
};

var NONE_DOCUMENT_ROOT_ITEM_TO_EXPAND = 0;

var CkVersion = {
    CK4: 0,
    CK5: 1
};